import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiFetch } from "../../shared/api";
import { clearTokens, getTokens, setTokens } from "../../shared/tokenStorage";

// redux-thunk: createAsyncThunk generates thunks under the hood
export const login = createAsyncThunk("auth/login", async ({ username, password }) => {
  const data = await apiFetch("/api/auth/login/", {
    method: "POST",
    body: { username, password },
  });

  const accessToken = data?.access;
  const refreshToken = data?.refresh;
  if (!accessToken || !refreshToken) {
    throw new Error("Login response missing access_token/refresh_token");
  }

  setTokens({ accessToken, refreshToken });
  return { accessToken, refreshToken };
});

export const fetchMe = createAsyncThunk("auth/fetchMe", async () => {
  return await apiFetch("/api/auth/me/", { method: "GET" });
});

export const updateMe = createAsyncThunk("auth/updateMe", async (data, { rejectWithValue }) => {
  try {
    return await apiFetch("/api/auth/me/", { method: "PATCH", body: data });
  } catch (err) {
    return rejectWithValue(err?.message || "Ошибка обновления профиля");
  }
});

const initialTokens = getTokens();

const authSlice = createSlice({
  name: "auth",
  initialState: {
    tokens: initialTokens,
    user: null,
    status: "idle",
    error: null,
  },
  reducers: {
    logout(state) {
      state.tokens = null;
      state.user = null;
      state.status = "idle";
      state.error = null;
      clearTokens();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.tokens = action.payload;
      })
      .addCase(login.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error?.message || "Login failed";
      })
      .addCase(fetchMe.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchMe.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.user = action.payload;
      })
      .addCase(fetchMe.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error?.message || "Failed to load user";
      })
      .addCase(updateMe.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateMe.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.user = { ...state.user, ...action.payload };
      })
      .addCase(updateMe.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Ошибка обновления профиля";
      });
  },
});

export const { logout } = authSlice.actions;

export const selectAuth = (state) => state.auth;
export const selectIsAuthenticated = (state) => Boolean(state.auth?.tokens?.accessToken);

export default authSlice.reducer;


